import * as React from "react";
import { useContext } from "react";
import { Link } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "../ui/breadcrumb";
import { SidebarTrigger } from "../ui/sidebar";
import { PageContext } from "../../components/layout/page";

export const Header = (): React.ReactElement => {
  const { breadCrumbs } = useContext(PageContext);

  return (
    <header className="fixed z-10 w-full bg-white flex h-14 shrink-0 items-center gap-2 transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-12 border-b">
      <div className="flex items-center gap-2 px-4 md:px-8">
        <SidebarTrigger className="md:hidden" />
        <Breadcrumb>
          <BreadcrumbList>
            {breadCrumbs?.map((crumb, i) => (
              <React.Fragment key={i}>
                <BreadcrumbItem className="text-lg font-medium text-neutral-700">
                  {crumb.link ? (
                    <BreadcrumbLink asChild>
                      <Link to={crumb.link} onClick={crumb.onClick}>
                        {crumb.text}
                      </Link>
                    </BreadcrumbLink>
                  ) : (
                    <BreadcrumbPage>{crumb.text}</BreadcrumbPage>
                  )}
                </BreadcrumbItem>
                {i < breadCrumbs.length - 1 && (
                  <BreadcrumbSeparator className="text-neutral-500 pt-1" />
                )}
              </React.Fragment>
            ))}
          </BreadcrumbList>
        </Breadcrumb>
      </div>
    </header>
  );
};
